import { render, staticRenderFns } from "./DetailsIns.vue?vue&type=template&id=3716ead0"
import script from "./DetailsIns.vue?vue&type=script&lang=js"
export * from "./DetailsIns.vue?vue&type=script&lang=js"
import style0 from "./DetailsIns.vue?vue&type=style&index=0&id=3716ead0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports